<template>
  <Paginator
    :first="first"
    :rows="5"
    :totalRecords="totalItems"
    @page="onPage($event)"
    template="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink"
  >
    <template #start>
      <Button type="button" icon="pi pi-refresh" @click="reset()" />
    </template>
    <template #end>
      <Button type="button" icon="pi pi-search" />
    </template>
  </Paginator>
</template>

<script scoped>
export default {
  data() {
    return {
    };
  },
  props: ["current-page", "page-size", "total-items", "currentItems"],
  emits: ["onChangePage"],
  methods: {
    convertTotalPageToArr() {
      const num = this.totalPages;
      this.totalPagesArr = Array.apply(null, { length: num }).map(
        Number.call,
        Number
      );
    },
    onPage(event) {
      this.$emit("onChangePage", event.page + 1);
    },
    reset() {
      this.first = 3;
    },
  },
  computed: {
    first() {
      return this.currentItems ? this.currentItems : 0
    }
  }
};
</script>

<style>
.pagination {
  display: flex;
  list-style: none;
  gap: 0.5rem;
}

.btn {
  width: 4rem;
  height: 4rem;
  background: #ffffff;
  border: 1px solid #e5e5e5;
  border-radius: 2px;
  font-size: 1.4rem;
  line-height: 2;
  color: #011837;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
}

.btn:hover,
.btn:active {
  border: 1px solid #8b95a0;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
  border-radius: 2px;
}

.btn-arrow {
  color: #8b95a0;
  letter-spacing: -4px;
}
</style>
